import React from "react";
import TopRangeNavbarSimple from "../components/TopRangeNavbarSimple";
import TopRangeFeedbackForm from "./feedback-sections/TopRangeFeedbackForm";
import TopRangeContacts from "../components/TopRangeContacts";
import TopRangeFooter from "../components/TopRangeFooter";
import ScrollToTop from "../components/ScrollToTop";


function TopRangeFeedback() {
  return (
    <>
      <TopRangeNavbarSimple />
      <TopRangeFeedbackForm />
      <TopRangeContacts />
      <TopRangeFooter />
      <ScrollToTop />
    </>
  );
}

export default TopRangeFeedback;